<template>
  <div class="tabFont">
    <div class="tabFontNameContext">
      <div class="tabFontName">{{ title }}</div>
    </div>
    <div class="tabFontChat" v-html="context"></div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    context: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="less" scoped>
.tabFont {
  font-family: "微软雅黑";
  padding: 20px 10px;
  display: flex;
  justify-content: center;
  height: 100%;
  .tabFontNameContext {
    height: 100%;
    .tabFontName {
      min-width: 70px;
      font-size: 25px;
      font-weight: bold;
      padding: 0 20px 0 0;
      text-align: right;
    }
  }
  .tabFontChat {
    font-size: 15px;
    letter-spacing: 1px;
  }
}
</style>
